import FichaNoConformidad from './pages/fichanoconformidad.page';
import NoConformidades from './pages/noconformidades.main.page';
import FormNoConformidad from './pages/formnoconformidad.page';
import NoConformidadCamaraPage from './pages/camara.page';
import FotosPage from './pages/fotos.page';


export default [
  {
    exact: true,
    path: '/noconformidades/listar',
    Component: NoConformidades,
  },
  {
    exact: true,
    path: '/noconformidades/mostrar/:id',
    Component: FichaNoConformidad,
  },
  {
    exact: true,
    path: '/noconformidades/crear',
    Component: FormNoConformidad,
  },
  {
    exact: true,
    path: '/noconformidades/editar/:id',
    Component: FormNoConformidad,
  },
  {
    exact: true,
    path: '/noconformidades/mostrar/:id/camara',
    Component: NoConformidadCamaraPage,
  },
  {
    exact: true,
    path: '/noconformidades/:id/fotos/:numFoto',
    Component: FotosPage,
  },
];
